<template>
    <div v-if="pending">
        <div class="d-flex justify-content-center loading-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
	<div v-else class="container py-5">
        <h2>{{ $t('selectionDetail') }}</h2>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <RouterLink to="/modelings">
                        {{ $t('home') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">
                    <RouterLink :to="{ name: 'modeling', params: { id: this.$route.params.id } }">
                        {{ modelingName || $t('modelings') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">{{ data.name }}</li>
            </ol>
        </nav>  
        <h3 class="text-center mb-4">{{ data.name }} 
            
            <RouterLink :to="'/modeling/' + this.$route.params.id + '/selectioninfo/' + this.$route.params.selectionId">
                <button class="btn btn-secondary float-end ">
                    {{ $t('detail') }}
                </button>
            </RouterLink>
            <template v-if="isUserAdmin">
                <button class="btn btn-secondary float-end me-2" @click="showAnalyseSelection = true">
                    {{ $t('runSimulation') }}
                </button>
                <button class="btn btn-secondary float-end me-2" @click="showValidateSelection = true">
                    {{ $t('validate') }}
                </button>
            </template>
        </h3>
        <div class="row mb-4">
            <div class="col-sm-3">
                <div class="card text-center">
                    <div class="card-body">
                        <h5 class="card-title">{{ $t("areas") }}</h5>
                    </div>
                    <ul class="list-group list-group-flush" v-if="data.selectionGroup.length >= 0"> 
                        <li class="list-group-item" v-for="(item, i) in data.selectionGroup" :key="i">
                            <RouterLink :to="'/modeling/' + this.$route.params.id + '/selection/' + this.$route.params.selectionId + '/group/' + item.id ">
                                {{ item.name }}
                            </RouterLink>
                        </li>
                    </ul>
                    <div class="card-body" v-if="isUserAdmin">
                        <RouterLink :to="'/modeling/' + this.$route.params.id + '/selection/' + this.$route.params.selectionId + '/groupcreate'">
                            <button class="btn btn-sm btn-light">{{ $t('addArea')}}</button>
                        </RouterLink>
                    </div>
                </div>
            </div>
            <div class="col-sm-3">
                <div class="card text-center">
                    <div class="card-body">
                        <h5 class="card-title">{{ $t("packages") }}</h5>
                    </div>
                    <ul class="list-group list-group-flush" v-if="data.selectionPackage.length >= 0"> 
                        <li class="list-group-item" v-for="(item, i) in data.selectionPackage" :key="i">
                            <RouterLink :to="'/modeling/' + this.$route.params.id + '/selection/' + this.$route.params.selectionId + '/package/' + item.id ">
                                {{ item.name }} 
                            </RouterLink>
                        </li>
                    </ul>
                    <div class="card-body" v-if="isUserAdmin">
                        <RouterLink :to="'/modeling/' + this.$route.params.id + '/selection/' + this.$route.params.selectionId + '/packagecreate'">
                            <button class="btn btn-sm btn-light">{{ $t('addPackage')}}</button>
                        </RouterLink>
                    </div>
                </div>
            </div>
            <div class="col-sm-3">
                <div class="card text-center">
                    <div class="card-body">
                        <h5 class="card-title">{{ $t("limits") }}</h5>
                    </div>
                    <ul class="list-group list-group-flush" v-if="data.selectionLimit.length >= 0"> 
                        <li class="list-group-item" v-for="(item, i) in data.selectionLimit" :key="i">
                            <RouterLink :to="'/modeling/' + this.$route.params.id + '/selection/' + this.$route.params.selectionId + '/limit/' + item.id ">
                                {{ item.name }}
                            </RouterLink>
                        </li>
                    </ul>
                    <div class="card-body" v-if="isUserAdmin">
                        <RouterLink :to="'/modeling/' + this.$route.params.id + '/selection/' + this.$route.params.selectionId + '/limitcreate' ">
                            <button class="btn btn-sm btn-light">{{ $t('addLimit')}}</button>
                        </RouterLink>
                    </div>
                </div>
            </div>
            <div v-if="analysisList.length > 0">
                <h3 class="text-center mb-4 mt-4">{{ $t('results') }}</h3>
                <table class="table table-bordered" style="border-radius:5px">
                    <thead>
                        <tr>
                            <th scope="col">{{ $t('forecastName') }}</th>
                            <th scope="col">{{ $t('selectionName') }}</th>
                            <th scope="col">{{ $t('selectionStartYear') }}</th>
                            <th scope="col">{{ $t('selectionEndYear') }}</th>
                            <th scope="col">{{ $t('createdDate') }}</th>
                            <th scope="col"></th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, i) in analysisList" :key="i" class="align-middle">
                            <td>
                                {{item.forecastName}}
                            </td>
                            <td>
                                {{item.selectionName}}
                            </td>
                            <td>
                                {{item.selectionStartYear}}
                            </td>
                            <td>
                                {{item.selectionEndYear}}
                            </td>
                            <td>
                                {{this.getCreatedDate(item.createdDate)}}
                            </td>
                            <td class="text-center">
                                <template v-if="item.state === 0 || item.state === 201">
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                </template>
                                <template v-else-if="item.state === 500">
                                    <span class="text-danger">
                                        {{ $t('resultFailed') }}
                                    </span>
                                </template>
                                <template v-else>
                                    <RouterLink :to="'/modeling/' + $route.params.id + '/modelingresult/' + item.id">
                                        <button class="btn btn-sm btn-light">{{ $t('detail') }}</button>
                                    </RouterLink>
                                </template>
                            </td>
                            <td>
                                <i style="display: block; text-align: center; cursor: pointer" @click="showDeleteModelingResultModal(item)" class="fas fa-sm fa-trash"></i>
                            </td>

                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <SelectionAnalyseModal v-if="showAnalyseSelection" @close="showAnalyseSelection = false" @started="closeAnalyseSetions" @confirm="showAnalyseSelection = false" />
        <ModelingResultDeleteModal v-if="showModelingResultDelete" @close="showModelingResultDelete = false" @confirm="confirmModelingResultDeletion"/>
        <SelectionValidateModal v-if="showValidateSelection" @close="showValidateSelection = false" @confirm="showValidateSelection = false" />
    </div>
</template>

<script>
import SelectionApi from "../../api/server/selection";
import ModelingApi from "../../api/server/modeling";
import AnalysisApi from "../../api/server/analysis";
import SelectionAnalyseModal from "./SelectionAnalyseModal.vue";
import SelectionValidateModal from "./SelectionValidateModal.vue";
import ModelingResultDeleteModal from "./ModelingResultDeleteModal.vue";

import CheckIfUserIsAdmin from '../../authCache';
import moment from 'moment';

export default {
    name: "selectiondetail",
    watch: {
        $route: "requestData",
    },
    components: {
        SelectionAnalyseModal,
        SelectionValidateModal,
        ModelingResultDeleteModal
    },
    mounted() {
        this.requestData();
    },
    methods: {
        async requestData() {
            this.pending = true;
            this.isUserAdmin = await CheckIfUserIsAdmin();

            var selectionId = this.$route.params.selectionId;
            this.data = await SelectionApi.selectionDetail(this.$route.params.id, selectionId);

            var modeling = await ModelingApi.modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;

            await this.loadAnalysisList();

            this.pending = false;
        },
        getCreatedDate(date) {
            return moment(date).format("DD.MM.YYYY HH:mm");
        },
        startPollingAnalysis() {
            if (this.pollingHandle) 
                return;
            this.pollingHandle = setInterval(() => {
                this.loadAnalysisList();
            }, 3000); // 3 vteřiny
        },
        async closeAnalyseSetions() {
            this.showAnalysisStarted();
            this.showAnalyseSelection = false;
            await this.loadAnalysisList();
            this.startPollingAnalysis();
        },
        async loadAnalysisList() {
            const selectionId = this.$route.params.selectionId;
            this.analysisList = await AnalysisApi.analysisList(this.$route.params.id,`?selectionId=${selectionId}`);
            
            // Pokud stále nějaký nedoběhl
            const hasRunning = this.analysisList.some(x => x.state === 0 || x.state === 201 );
            if (!hasRunning && this.pollingHandle) {
                clearInterval(this.pollingHandle);
                this.pollingHandle = null;
            }
        },
        showDeleteModelingResultModal(item) {
            this.modelingResultIdToDelete = item.id;
            this.showModelingResultDelete = true;
        },
        async confirmModelingResultDeletion() {
            await this.loadAnalysisList();
            this.showModelingResultDelete = false;
            this.showModelingResultDeleted();
        }
    },
    beforeUnmount() {
        if (this.pollingHandle) {
            clearInterval(this.pollingHandle);
        }
    },
    notifications: {
        showSuccess: {
            title: 'success',
            message: 'selectionUpdated',
            type: 'success'
        },
        showError: {
            title: 'error',
            message: 'selectionErrorUpdate',
            type: 'error'
        },
        showModelingResultDeleted: {
            title: 'success',
            message: 'modelingResultDeleted',
            type: 'success'
        },
        showAnalysisStarted: { 
            title: 'success',
            message: 'analysisStarted',
            type: 'success'
        },
    },
    data() {
        return {
            data: {
                name: "",
                id: 0,
                forecastId: 0,
                selectionGroup: [],
                selectionPackage: [],
                selectionLimit: []
            },
            analysisList: [],
            showSelectionDeleteModal: false,
            showAnalyseSelection: false,
            showValidateSelection: false,
            showModelingResultDelete: false,
            modelingResultIdToDelete: null,
            pending: true,
            modelingName: "",
            isUserAdmin: false,
            pollingHandle: null
        }
    }
};
</script>